import React from "react";
import smoothscroll from "smoothscroll-polyfill";
import Provider from "~/store";
import "~/assets/styles/index.scss";

smoothscroll.polyfill();

export const onRouteUpdate = () => {
  if (document.querySelector(".instagram-media") !== null) {
    // Wait to ensure page is rendered first.
    setTimeout(() => {
      if (
        typeof gatsbyLoadInstagram !== `undefined` &&
        typeof window.gatsbyLoadInstagram === `function`
      ) {
        window.gatsbyLoadInstagram();
      }
    }, 0);
  }
};

export const wrapRootElement = ({ element }) => <Provider>{element}</Provider>;
